import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/pages/activities/card/index.ts